module.exports = __webpack_public_path__ + "img/academy.7e2b5b97.png";